(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5240],{

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Affix; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(847);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69777);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79729);
/* harmony import */ var _Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21589);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14661);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  position: { bottom: 0, right: 0 },
  zIndex: (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultZIndex */ .w)("modal"),
  withinPortal: true
};
const Affix = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_2__/* .useComponentDefaultProps */ .N4)("Affix", defaultProps, props), { target, position, zIndex, sx, withinPortal, portalProps } = _a, others = __objRest(_a, ["target", "position", "zIndex", "sx", "withinPortal", "portalProps"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__/* .OptionalPortal */ .q, __spreadProps(__spreadValues({}, portalProps), {
    withinPortal,
    target
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, __spreadValues({
    sx: [__spreadValues({ position: "fixed", zIndex }, position), ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_5__/* .packSx */ .R)(sx)],
    ref
  }, others)));
});
Affix.displayName = "@mantine/core/Affix";


//# sourceMappingURL=Affix.js.map


/***/ }),

/***/ 72839:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates",
      function () {
        return __webpack_require__(12527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ templates; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/components/site/SiteLayout/index.tsx + 24 modules
var SiteLayout = __webpack_require__(96895);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/modules/Site/Templates/Jumbotron/index.module.scss
var index_module = __webpack_require__(31987);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/modules/Site/Templates/Jumbotron/index.tsx




var Jumbotron = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        className: classnames_default()((index_module_default()).jumbotron, className),
        pt: 192,
        spacing: 0,
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                weight: 900,
                className: "sm:leading-[81px] leading-[48px] text-[32px] sm:text-[56px] mb-[8px] sm:mb-[12px]",
                children: "如何在真实场景使用浩客"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "sm:leading-[25px] sm:text-[18px] leading-[24px] text-[16px]",
                children: "需要灵感？不妨看看以下模板\uD83E\uDDD0"
            })
        ]
    });
};
/* harmony default export */ var Templates_Jumbotron = (Jumbotron);

// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(65180);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(12667);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Affix/Affix.js
var Affix = __webpack_require__(354);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Transition/Transition.js + 3 modules
var Transition = __webpack_require__(49954);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
;// CONCATENATED MODULE: ./src/modules/Site/Templates/CategoryAffixTab/index.tsx







var CategoryAffixTab = function() {
    var tabRef = (0,react.useRef)(null);
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 2), scroll = ref[0], scrollTo = ref[1];
    var scrollY = smallerScreen ? 330 : 380;
    var handleChange = function(category, option) {
        scrollTo({
            y: option.top - 190
        });
    };
    var handleScroll = function() {
        var ref;
        tabRef === null || tabRef === void 0 ? void 0 : (ref = tabRef.current) === null || ref === void 0 ? void 0 : ref.onScroll(100);
    };
    (0,use_window_event/* useWindowEvent */.s)("scroll", handleScroll);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xl",
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Affix/* Affix */.D, {
                position: {
                    top: "57px"
                },
                zIndex: 1002,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* Transition */.u, {
                    transition: "fade",
                    mounted: scroll.y > scrollY,
                    children: function(transitionStyles) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            className: "sm:h-[56px] h-[114px]",
                            sx: function(theme) {
                                return {
                                    width: "100vw",
                                    background: "white",
                                    opacity: "0.8",
                                    height: "56px",
                                    borderBottom: "1px solid ".concat(theme.colors.gray[2]),
                                    backdropFilter: "blur(10px)"
                                };
                            },
                            style: transitionStyles,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* CampaignTemplateCategoryTab */.dQ, {
                                ref: tabRef,
                                autoSelected: true,
                                onChange: handleChange
                            })
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* CampaignTemplateCategoryTab */.dQ, {
                autoSelected: true,
                onChange: handleChange
            })
        ]
    });
};
/* harmony default export */ var Templates_CategoryAffixTab = (CategoryAffixTab);

;// CONCATENATED MODULE: ./src/pages/templates/index.tsx










var TemplatesPage = function(param) {
    var templates = param.templates;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "场景模板 - 浩客HowXM模板中心 - 应用内调研、评价、通知模板 - NPS 调研模板 - 评价反馈模板"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ResponsiveHead */.eG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* GridBackground */.o9, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    size: 1200,
                    className: "pb-11 pt-[123px]",
                    px: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Templates_Jumbotron, {
                            className: "sm:mb-[26px] mb-[28px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                            position: "center",
                            mb: 42,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Templates_CategoryAffixTab, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* CampaignTemplateCategories */.lk, {
                            templates: templates,
                            source: "site"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FooterWrapper */.V6, {
                className: "pt-[159px]"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var templates = (TemplatesPage);


/***/ }),

/***/ 31987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"Jumbotron_jumbotron__SdHm4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(72839); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);